import axios from 'axios';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { QrReader } from 'react-qr-reader';
import CONFIG from '../constanta/config';
import Cookies from 'js-cookie';
import useReport from '../hook/useReport';

const PopupAddUser = (props) => {
  const localReport = useReport();
  const [msgerror, setMsgerror] = useState('');
  const [msgsuskes, setMsgsukses] = useState('');
  const [msgName, setMsgName] = useState('');
  const [loading, setLoading] = useState(false);
  const [sukses, setSukses] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(count + 1);
      handleCheckinTime();
    }, 1000 * 5);

    return () => clearInterval(interval);
  }, [count]);

  useEffect(() => {
    localReport.fetchData();
  }, []);

  const handleCheckinTime = async () => {
    localReport.fetchData();
  };

  const handleSubmit = () => {
    setMsgName('');

    let name = getValue('input_name');
    if (name === '') {
      setMsgName('Please type your name');
      return;
    }

    let email = getValue('input_email');
    if (email === '') {
      setMsgName('Please type your email');
      return;
    }

    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMsgName('Invalid email format');
      return;
    }

    let contact = getValue('input_contact');
    if (contact === '') {
      setMsgName('Please type your contact');
      return;
    }

    let company = getValue('input_company');
    if (company === '') {
      setMsgName('Please type your email');
      return;
    }

    setLoading(true);
    setSukses(false);

    const payload = {
      name: name,
      email: email,
      contact: contact,
      company: company
    };

    openInNewWindow(
      `/printcode?name=${name}&contact=${contact}&email=${email}&company=${company}`
    );

    setTimeout(() => {
      handleOnClose();
    }, 1500);

    return;

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    //console.log(Cookies.get('token'));

    axios
      .post(CONFIG.URL + '/contact/added', form_data)
      .then(function (response) {
        if (response?.data.status === 'sukses') {
          setSukses(true);
          setMsgsukses('Success Add Contact');

          openInNewWindow(
            `/printcode?name=${response?.data?.user?.name}&contact=${response?.data?.user?.contact}&email=${response?.data?.user?.email}&company=${response?.data?.user?.company}`
          );

          setTimeout(() => {
            handleOnClose();
          }, 1500);
        } else {
          setMsgerror('Error add contact please try again.');
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const getValue = (id) => {
    let name = window.document.getElementById(id).value;
    return name;
  };

  const getValueDOB = () => {
    let dob = window.document.getElementById('input_dob').value;
    return dob;
  };

  const openInNewWindow = (url) => {
    const windowFeatures =
      'menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes,width=800,height=600';
    const newWindow = window.open(url, '_blank', windowFeatures);

    if (newWindow) {
      newWindow.onload = () => {
        setTimeout(() => {
          newWindow.print();
          newWindow.onafterprint = () => {
            newWindow.close();
          };
        }, 1000);
      };
    }
  };

  const handleOnClose = () => {
    setSukses(false);
    setMsgsukses('');
    setMsgerror('');
  };

  return (
    <>
      <form className="w-full">
        {/* <div className="absolute z-20 top-0 left-0 w-screen h-screen bg-[#000000b3]"></div> */}
        <div className="absolute py-20 z-50  top-0 left-0 w-screen h-screen flex flex-col justify-center items-center">
          <div className="p-4 bg-white rounded-lg w-full max-w-lg">
            <div className=" flex flex-col w-full max-w-lg">
              {!sukses && (
                <>
                  <div className="flex flex-col space-y-2 mb-10">
                    <div className=" text-black text-center font-bold text-2xl uppercase">
                      Total Printed : {localReport?.data?.jumlah ?? '0'}
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="text-black mb-1">Name:</div>
                    <input
                      autoFocus
                      id="input_name"
                      placeholder="Type your name"
                      autocomplete="off"
                      className=" w-full  min-w-[160px] px-2 py-2 bg-white border-2 border-black rounded-lg text-black"
                    />
                  </div>

                  <div className="mb-2">
                    <div className="text-black mb-1">Email:</div>
                    <input
                      type="email"
                      id="input_email"
                      placeholder="Type your email"
                      autocomplete="off"
                      className=" w-full  min-w-[160px] px-2 py-2 bg-white border-2 border-black rounded-lg text-black"
                    />
                  </div>

                  <div className="mb-2">
                    <div className="text-black mb-1">Contact:</div>
                    <input
                      type="number"
                      id="input_contact"
                      placeholder="Type your contact"
                      autocomplete="off"
                      className=" w-full  min-w-[160px] px-2 py-2 bg-white border-2 border-black rounded-lg text-black"
                    />
                  </div>

                  <div className="mb-2">
                    <div className="text-black mb-1">Company:</div>
                    <input
                      id="input_company"
                      placeholder="Type your company"
                      autocomplete="off"
                      className=" w-full  min-w-[160px] px-2 py-2 bg-white border-2 border-black rounded-lg text-black"
                    />
                  </div>
                </>
              )}
              {msgName !== '' && (
                <div className="w-full font-bold mt-2 max-w-lg text-center px-2 rounded-md bg-white text-red-500">
                  {msgName}
                </div>
              )}

              {msgerror !== '' && !sukses && (
                <div className="mt-10 w-full text-2xl max-w-lg text-center py-2 px-2 rounded-md my-2 bg-red-500 text-white font-bold">
                  {msgerror}
                </div>
              )}

              {msgsuskes !== '' && (
                <div className="w-full text-2xl max-w-lg text-center py-2 px-2 rounded-md my-2  text-green-500 font-bold">
                  {msgsuskes}
                </div>
              )}
            </div>

            {!loading ? (
              <>
                {sukses ? (
                  <div className=" w-full flex justify-center items-center mt-10 space-x-5">
                    <button
                      type="button"
                      onClick={() => handleOnClose()}
                      className="min-w-[160px] px-10 py-2 bg-green-500 rounded-lg text-white font-bold">
                      OK
                    </button>
                  </div>
                ) : (
                  <div className=" w-full flex justify-center items-center mt-10 space-x-5">
                    {/* <button
                      type="button"
                      onClick={() => handleOnClose()}
                      className="min-w-[160px] px-10 py-2 bg-red-500 rounded-lg text-white font-bold">
                      Try Again
                    </button> */}

                    <button
                      type="button"
                      onClick={() => handleSubmit()}
                      className="min-w-[160px] px-10 py-2 bg-blue-500 rounded-lg text-white font-bold">
                      SUBMIT
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className=" w-full flex justify-center items-center mt-10 space-x-5">
                <button
                  type="button"
                  onClick={() => props.onSuccess()}
                  className="min-w-[160px] px-10 py-2 bg-transparent rounded-lg text-black font-bold">
                  Loading, please wait...
                </button>
              </div>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default PopupAddUser;
